class FormSearch {
  constructor($el) {
    this.$el = $el;
    this.$filter = this.$el.querySelectorAll('select');
    this.$filterHeader = this.$el.querySelectorAll('.form-search__filter-header');
    this.$reset = this.$el.querySelector('.search-input__reset');

    this.init();
  }

  init() {
    this.initReset();
    this.initFilterTabs();
  }

  initReset() {
    if (this.$reset) {
      this.$reset.addEventListener('click', () => {
        this.$filter.forEach(($filter) => {
          const $el = $filter;

          $el.selectedIndex = 0;
        });
      });
    }
  }

  initFilterTabs() {
    if (!this.$filterHeader) {
      return;
    }
    this.$filterHeader.forEach(
      $filterHeader => $filterHeader.addEventListener('click', (event) => {
        // Current target
        const $currentTarget = event.currentTarget;

        // Current control
        const $currentControl = this.$el.querySelector(
          `[id=${$currentTarget.getAttribute('aria-controls')}]`,
        );

        // State
        const currentState = $currentTarget.getAttribute('aria-expanded');

        // Update states
        if (currentState === 'true') {
          $currentControl.setAttribute('aria-hidden', 'true');
          $currentTarget.setAttribute('aria-expanded', 'false');
        } else {
          $currentControl.setAttribute('aria-hidden', 'false');
          $currentTarget.setAttribute('aria-expanded', 'true');
        }
      }),
    );
  }
}

document.querySelectorAll('.js-form-search').forEach(
  $form => new FormSearch($form),
);



// WEBPACK FOOTER //
// ./src/components/organisms/form-search/form-search.js